<template>
    <div class="classifyBox">
        <div class="classifyItem">
            <div>
                <div :class="['meItem', {'active':mIndex == index}]" @click="selectMenu(index)" v-for="(item, index) in itemList" :key="index">{{item.name}}</div>
            </div>
        </div>
        <div class="classifyBody">
            <div>
                <div class="classifyContent"   v-for="(item, index) in panelList" :key="index">
                    <slot :data="item"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bscroll from 'better-scroll'
    export default {
        name: "classify",
        props:{
            itemArr:{
                type:Array
            },
            panelArr:{
                type: Array
            }
        },
        data(){
            return {
                mIndex:0,
                itemList:this.itemArr,
                panelList:this.panelArr,
                heightList:[],
            }
        },
        methods:{
            classifyItem(){
                let el = document.querySelector(".classifyItem")
                this.itemAll = document.querySelectorAll('.meItem');
                this.emItem = new bscroll(el,{
                    click:true
                })
            },
            classifyContent(){
                let el = document.querySelector(".classifyBody")
                this.cententBox = document.querySelectorAll('.classifyContent')
                this.cententBox.forEach(item => {
                    this.heightList.push(item.offsetTop)
                })
                let windowScrollHeight = el.offsetHeight
                this.content = new bscroll(el, {
                    probeType:3
                })
                this.content.on('scroll',(obj) => {
                    let y = Math.abs(Math.round(obj.y))
                    for(let i=0; i< this.heightList.length; i++){
                        let h1 = this.heightList[i]
                        let idx =(i+1)>this.heightList.length? this.heightList.length:i+1
                        let h2 = this.heightList[idx]
                        if((y+windowScrollHeight) >= el.firstChild.offsetHeight){
                            this.mIndex = this.heightList.length-1
                        }else {
                            if(h1<=y && y<=h2){
                                this.mIndex = i
                            }
                        }
                    }
                    this.emItem.scrollToElement(this.itemAll[this.mIndex], 300)
                })
            },
            selectMenu(index){
                this.mIndex=index
                this.content.scrollToElement(this.cententBox[index], 300)

            }
        },
        mounted() {
            setTimeout(()=>{
                this.classifyItem()
                this.classifyContent()
            },80)
        }
    }
</script>

<style scoped lang="scss">
    .classifyBox{
        width: 100%;
        height: 100%;
        display: flex;
        .classifyItem{
            position: relative;
            width: 80px;
            height: 100%;
            overflow: hidden;
            background-color: #fff;
            box-shadow: 0px 1px 4px 0 rgba(0,0,0,0.1);
            z-index: 100;
            .meItem{
                height: 48px;
                font-size: 14px;
                text-align: center;
                line-height: 48px;
            }
        }
        .classifyBody{
            flex: 1;
            height: 100%;
            overflow: hidden;
            .classifyContent{
                background-color: #fff;
                min-height: 300px;
            }
        }
        .active{
            color: #ed0000;
        }
    }
</style>

